exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._22sXHoUHHiKNL4h8sW0BBY{padding-left:.5em;padding-right:.5em;letter-spacing:2px}", "", {"version":3,"sources":["/var/www/fsa/skopei-portal/src/components/UI/Loading/Dots/Dots.scss"],"names":[],"mappings":"AAYA,yBACE,kBAAoB,AACpB,mBAAqB,AACrB,kBAAoB,CAAE","file":"Dots.scss","sourcesContent":["/* * * * * * * * *\n * NAMED COLORS  *\n * * * * * * * * */\n/* * * * * * * * * * *\n * INTERFACE COLORS  *\n * * * * * * * * * * */\n/* * * * * * * * *\n * BRAND COLORS  *\n * * * * * * * * */\n/* * * * * * * * * * * * * * *\n * SET DEFAULT BRAND COLORS  *\n * * * * * * * * * * * * * * */\n.dots {\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n  letter-spacing: 2px; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"dots": "_22sXHoUHHiKNL4h8sW0BBY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"sourceMap":true,"importLoaders":2}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/components/UI/Loading/Dots/Dots.scss
// module id = 684
// module chunks = 14